<template>
  <div v-if="loading">
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
  <div style="height: 100%" v-else>
    <v-stepper v-model="step" vertical>
      <v-stepper-step :editable="true" step="1">
        {{ $t("components.vuematerialdashboard.core.appbar.help") }}
        <small>
          {{ $t("components.formulabuilder.help_description") }}
        </small>
      </v-stepper-step>
      <v-stepper-content step="1">
        <div style="margin: 10px">
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("components.formulabuilder.help_text_code") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <pre
                  style="background:#f6f6f6; padding: 10px; color:#222; width:100%;word-wrap: break-word;overflow-wrap: break-word;white-space: pre-wrap;  "
                  >{{
                    $t("components.formulabuilder.help_text_code_content")
                  }}</pre
                >
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("components.formulabuilder.help_text_visual") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <pre
                  style="background:#f6f6f6; padding: 10px; color:#222; width:100%;word-wrap: break-word;overflow-wrap: break-word;white-space: pre-wrap;  "
                  >{{
                    $t("components.formulabuilder.help_text_visual_content")
                  }}</pre
                >
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("components.formulabuilder.help_text_validate") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <pre
                  style="background:#f6f6f6; padding: 10px; color:#222; width:100%;word-wrap: break-word;overflow-wrap: break-word;white-space: pre-wrap;  "
                  >{{
                    $t("components.formulabuilder.help_text_validate_content")
                  }}</pre
                >
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel>
              <v-expansion-panel-header>
                {{ $t("components.formulabuilder.help_text_examples") }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <pre
                  style="background:#f6f6f6; padding: 10px; color:#222; width:100%;word-wrap: break-word;overflow-wrap: break-word;white-space: pre-wrap;  "
                  >{{
                    $t("components.formulabuilder.help_text_examples_content")
                  }}</pre
                >
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div style="margin:10px">
          <v-btn class="ma-1" color="primary" @click="step = 2">
            {{ $t("globals.continue") }}
          </v-btn>
        </div>
      </v-stepper-content>
      <v-stepper-step :editable="true" :complete="step > 2" step="2">
        {{ $t("components.formulabuilder.build_formula") }}
        <small>
          {{ $t("components.formulabuilder.build_formula_description") }}
        </small>
      </v-stepper-step>
      <v-stepper-content step="2">
        <code-editor
          style="height: 50vh"
          ref="codeEditor"
          :functions="functions"
          :parameters="parameters"
          :variables="variables"
          v-on:update="
            valid = tested = false;
            $emit('tested', false);
            $emit('valid', false);
          "
          v-on:valid="onUsedParametersChanged"
          :actualCode.sync="innerCode"
        >
          <template v-slot:actions>
            <!-- <v-btn
          class="ma-1"
          color="primary"
          @click="
            save({
              code: $refs.codeEditor.actualCode,
              args: $refs.codeEditor.usedParameters,
            })
          "
          :disabled="!tested"
        >Save</v-btn>-->
          </template>
        </code-editor>
        <v-btn text class="ma-1" @click="step--">
          {{ $t("globals.back") }}
        </v-btn>
        <v-btn
          color="primary"
          class="ma-1"
          @click="step = 3"
          :disabled="!innerCode || !valid"
        >
          {{ $t("globals.continue") }}
        </v-btn>
      </v-stepper-content>
      <v-stepper-step :editable="true" step="3">
        {{ $t("components.formulabuilder.validate_save") }}
        <small>
          {{ $t("components.formulabuilder.validate_save_description") }}
        </small>
      </v-stepper-step>
      <v-stepper-content step="3">
        <v-dialog max-width="300px" v-model="showDialog">
          <v-card>
            <v-card-title>Result</v-card-title>
            <v-card-text>
              <span class="result">{{ result }}</span>
            </v-card-text>
          </v-card>
        </v-dialog>
        <div
          style="height: 100%; overflow-y:auto; display:flex; flex-direction: column"
          v-if="usedParameters"
        >
          <v-row
            style="padding: 20px;display:flex; flex:1;overflow-y:auto;"
            no-gutters
          >
            <v-col
              v-for="entry of Object.keys(usedParameters)"
              :key="entry"
              cols="12"
              sm="4"
              md="3"
              lg="2"
              style="margin: 6px"
            >
              <no-autocomplete-textfield
                v-if="usedParameters[entry].type === 'System.String'"
                :placeholder="$t('components.formulabuilder.set_a_value')"
                outlined
                dense
                :label="entry"
                :value="usedParameters[entry].value"
                @input="usedParameters[entry].value = $event"
                hide-details
              />
              <no-autocomplete-textfield
                v-if="
                  usedParameters[entry].type === 'System.Double' ||
                    usedParameters[entry].type === 'System.Decimal'
                "
                type="number"
                :placeholder="$t('components.formulabuilder.set_a_value')"
                outlined
                dense
                step="0.1"
                :label="entry"
                :value="usedParameters[entry].value"
                @input="usedParameters[entry].value = $event"
                hide-details
              />
              <no-autocomplete-textfield
                v-if="usedParameters[entry].type === 'System.Int32'"
                type="number"
                :placeholder="$t('components.formulabuilder.set_a_value')"
                outlined
                dense
                :label="entry"
                :value="usedParameters[entry].value"
                @input="usedParameters[entry].value = $event"
                hide-details
              />
              <v-checkbox
                v-if="usedParameters[entry].type === 'System.Boolean'"
                :label="entry"
                v-model="usedParameters[entry].value"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <div style="display:flex; flex:0; padding: 10px; background: #f1f1f1">
            <v-btn text class="ma-1" @click="step--">
              {{ $t("globals.back") }}
            </v-btn>
            <v-btn
              color="primary"
              class="ma-1"
              @click="
                test({
                  code: $refs.codeEditor.actualCode,
                  args: usedParameters,
                })
              "
              :disabled="!innerCode || !valid"
            >
            {{$t('components.formulabuilder.test')}}
            </v-btn>
          </div>
        </div>
      </v-stepper-content>
    </v-stepper>
    <error-handler :error="error"></error-handler>
  </div>
</template>
<script>
import { CodeArgument, CodeFunction } from "pbas-vue-components";
import { mapGetters, mapActions } from "vuex";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import ErrorHandler from "@/components/ErrorHandler";
export default {
  name: "formula-builder",
  components: {
    NoAutocompleteTextfield,
    ErrorHandler,
  },
  props: [
    "planIdentityId",
    "params",
    "code",
    "fields",
    "coverage",
    "trackHours",
    "hasStores",
    "planVariables"
  ],
  data: () => ({
    step: 1,
    functions: [],
    parameters: [],
    variables: [],
    showDialog: false,
    result: null,
    valid: false,
    tested: false,
    innerCode: "",
    usedParameters: null,
    error: null,
    loading:false,
  }),
  watch: {
    params: {
      handler(v) {
        if (v) {
          this.parameters = v.map(
            (p) =>
              new CodeArgument(
                p.SystemName,
                null,
                p.Description,
                p.Identity?p.Identity.CurrentDefaultValue.Value:null,
                p.Type,
                p.ParameterType
              )
          );
        }
      },
      deep: true,
    },
    formula: {
      handler(v) {
        if (v) {
          this.$refs.codeEditor.actualCode = v.Formula;
        }
      },
      deep: true,
    },
    innerCode: {
      handler(v) {
        if (v) {
          this.$emit("update:code", this.innerCode);
        }
      },
      deep: true,
    },
    code: {
      handler(v) {
        if (v) {
          this.innerCode = v;
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    try {
      this.loading = true;
      this.functions = [
        new CodeFunction(
          "Abs",
          this.$t("components.formulabuilder.abs"),
          "Abs(-1) ⇾ 1M",
          [new CodeArgument("value")]
        ),
        new CodeFunction(
          "Acos",
          this.$t("components.formulabuilder.acos"),
          "Acos(1) ⇾ 0d",
          [new CodeArgument("angle")]
        ),
        new CodeFunction(
          "Asin",
          this.$t("components.formulabuilder.asib"),
          "Asin(0) ⇾ 0d",
          [new CodeArgument("angle")]
        ),
        new CodeFunction(
          "Atan",
          this.$t("components.formulabuilder.atan"),
          "Atan(0) ⇾ 0d",
          [new CodeArgument("angle")]
        ),
        new CodeFunction(
          "Ceiling",
          this.$t("components.formulabuilder.ceiling"),
          "Ceiling(1.5) ⇾ 2d",
          [new CodeArgument("value")]
        ),
        new CodeFunction(
          "Cos",
          this.$t("components.formulabuilder.cos"),
          "Cos(0) ⇾ 1d",
          [new CodeArgument("angle")]
        ),
        new CodeFunction(
          "Exp",
          this.$t("components.formulabuilder.exp"),
          "Exp(0) ⇾ 1d",
          [new CodeArgument("power")]
        ),
        new CodeFunction(
          "Floor",
          this.$t("components.formulabuilder.floor"),
          "Floor(1.5) ⇾ 1d",
          [new CodeArgument("value")]
        ),
        new CodeFunction(
          "IEEERemainder",
          this.$t("components.formulabuilder.iEEERemainder"),
          "IEEERemainder(3, 2) ⇾ -1d",
          [new CodeArgument("number1"), new CodeArgument("number2")]
        ),
        new CodeFunction(
          "if",
          this.$t("components.formulabuilder.if"),
          "if(3 % 2 = 1, 'value is true', 'value is false') ⇾ 'value is true'",
          [
            new CodeArgument("expression"),
            new CodeArgument("expressionForTrue"),
            new CodeArgument("expressionForFalse"),
          ]
        ),
        new CodeFunction(
          "in",
          this.$t("components.formulabuilder.in"),
          "in(1 + 1, 1, 2, 3) ⇾ true",
          [
            new CodeArgument("needle"),
            new CodeArgument("haystack1"),
            new CodeArgument("haystack2"),
          ]
        ),
        new CodeFunction(
          "Log",
          this.$t("components.formulabuilder.log"),
          "Log(1, 10) ⇾ 0d",
          [new CodeArgument("number"), new CodeArgument("base")]
        ),
        new CodeFunction(
          "Log10",
          this.$t("components.formulabuilder.log10"),
          "Log10(1) ⇾ 0d",
          [new CodeArgument("number")]
        ),
        new CodeFunction(
          "Max",
          this.$t("components.formulabuilder.max"),
          "Max(1, 2) ⇾ 2",
          [new CodeArgument("num1"), new CodeArgument("num2")]
        ),
        new CodeFunction(
          "Min",
          this.$t("components.formulabuilder.min"),
          "Min(1, 2) ⇾ 1",
          [new CodeArgument("number"), new CodeArgument("base")]
        ),
        new CodeFunction(
          "Pow",
          this.$t("components.formulabuilder.pow"),
          "Pow(3, 2) ⇾ 9d",
          [new CodeArgument("number"), new CodeArgument("power")]
        ),
        new CodeFunction(
          "Round",
          this.$t("components.formulabuilder.round"),
          "Round(3.222, 2) ⇾ 3.22d",
          [new CodeArgument("number1"), new CodeArgument("number2")]
        ),
        new CodeFunction(
          "SerialIf",
          this.$t("components.formulabuilder.serial_if"),
          "SerialIf([Condition1],result1,[Condition2],result2,result3) ⇾ result1 if Condition1 is met",
          []
        ),
        new CodeFunction(
          "Sign",
          this.$t("components.formulabuilder.sign"),
          "Sign(-10) ⇾ -1",
          [new CodeArgument("number")]
        ),
        new CodeFunction(
          "Sin",
          this.$t("components.formulabuilder.sin"),
          "Sin(0) ⇾ 0d",
          [new CodeArgument("angle")]
        ),
        new CodeFunction(
          "Sqrt",
          this.$t("components.formulabuilder.sqrt"),
          "Sqrt(4) ⇾ 2d",
          [new CodeArgument("number")]
        ),
        new CodeFunction(
          "Tan",
          this.$t("components.formulabuilder.tan"),
          "Tan(0) ⇾ 0d",
          [new CodeArgument("angle")]
        ),
        new CodeFunction(
          "Truncate",
          this.$t("components.formulabuilder.truncate"),
          "Truncate(1.7) ⇾ 1",
          [new CodeArgument("angle")]
        ),
      ];
      this.parameters = this.params.map((p) => {
        if (
          p.ConfigurationParameter !== null &&
          p.ConfigurationParameter !== undefined
        ) {
          return new CodeArgument(
            p.ConfigurationParameter.SystemName,
            null,
            p.ConfigurationParameter.Description,
            p.ConfigurationParameterValue.Value,
            p.ConfigurationParameter.Type,
            p.ConfigurationParameter.ParameterType
          );
        }
        return new CodeArgument(
          p.SystemName,
          null,
          p.Description,
          p.Identity?p.Identity.CurrentDefaultValue.Value:null,
          p.Type,
          p.ParameterType
        );
      });
      let planVariables = [];
      if (this.planVariables) {
        planVariables = this.planVariables;
      } else {
        planVariables = (await this.getPlanVariablesBuilder({
        planIdentityId: this.planIdentityId, //"c8380bca-674d-46b1-97c7-64dea63784c6",
        payload: {
          Fields: this.fields,
          Coverages: JSON.parse(JSON.stringify(this.coverage)).map(o=>{
            delete o.TrustFund;
            return o;
          }),
          TrackHours: this.trackHours,
          HasStores: this.hasStores,
        },
      }));
      }
      this.variables = planVariables.map(
        (p) =>
          new CodeArgument(
            p.Key,
            null,
            p.Label,
            p.Type === "System.Boolean" ? true : "",
            p.Type,
            p.ParameterType
          )
      );
    } catch (error) {
      this.error = error;
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapActions("plansMembers", ["getPlanVariablesBuilder", "testFormula"]),
    onUsedParametersChanged($event) {
      this.$emit("valid", $event);
      this.valid = $event;
      let p = this.$refs.codeEditor ? this.$refs.codeEditor.usedParameters : [];
      this.usedParameters = [];
      let compositeExists = false;
      for (let key of Object.keys(p)) {
        if (p[key].parameterType === "CompositeWithProvince") {
          compositeExists = true;
          let composite = p[key];
          let provinces = JSON.parse(composite.value);
          for (let province of Object.keys(provinces)) {
            this.usedParameters[province] = {
              type: composite.type,
              value: provinces[province],
            };
          }
        } else {
          this.usedParameters[key.substring(1, key.length - 1)] = p[key];
        }
      }
      if (compositeExists) {
        if (
          Object.keys(this.usedParameters).filter((o) => o === "Province.Code")
            .length === 0
        ) {
          this.usedParameters["Province.Code"] = {
            type: "System.String",
            value: null,
          };
        }
      }
      // this.usedParameters = p.filter(o=>o.parameterType !== "CompositeWithProvince");
    },
    convertToString(value) {
      if (value === null || value === undefined) {
        return "";
      }
      if (typeof value === "number") {
        return parseFloat(value).toFixed(4);
      }
      return value;
    },
    async test(what) {
      console.log(what)
      try {
        if (Object.keys(what.args).some((k) => what.args[k].value === "")) {
          throw new Error(this.$t("components.formulabuilder.error"));
        }
        const payload = {
          Formula: what.code,
          Parameters: {},
        };
        for (const key of Object.keys(what.args)) {
          payload.Parameters[key] = {
            Value: this.convertToString(what.args[key].value),
            SystemType: what.args[key].type,
          };
        }
        this.result = await this.testFormula(payload);
        this.tested = true;
        this.$emit("tested", true);
      } catch (e) {
        this.result = e;
      }
      this.showDialog = true;
    },
  },
};
</script>
<style scoped>
.result {
  font-size: 18px;
}
</style>
<style>
.ace_hidden-cursors {
  opacity: 0;
}
</style>
